import { MapsAPILoader } from "@agm/core";
import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import {
  InstaCitiCountries,
  InstacitiMetadata,
  InstaNearByLocality,
  InstaPopularCity,
} from "../instaciti-new.interface";
import { InstacitiSupportComponent } from "../instaciti-support/instaciti-support.component";
import { InstacitiNewService } from "../service/instaciti-new.service";
declare function Tooltip(): any;
@Component({
  selector: "portal-instaciti-landing",
  templateUrl: "./instaciti-landing.component.html",
  styleUrls: ["./instaciti-landing.component.css"],
})
export class InstacitiLandingComponent implements OnInit {
  placeholder: string = "Type to search...";
  localityPlaceholder: string = "Type to search...";
  manikJson: InstacitiMetadata;
  isQuickVisible: boolean;
  isPromotedVisible: boolean;
  isPopularVisible: boolean;
  popularCities: InstaPopularCity[] = [];
  isOtherVisible: boolean;
  selectedKeyWord = { Keywd: "" };
  logoURL: string =
    "https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/instaciti-logo.png";
  countries: InstaCitiCountries[] = [];
  location: string;
  locality: string;
  cities = [];
  selectedCountry;
  locationDetected: boolean = false;
  nearby: InstaNearByLocality[] = [];
  selectedCity;
  latitude: number;
  longitude: number;
  searchResult: [];
  zoom: number;
  address: string;
  searchText: string;
  private geoCoder;
  modalRef: MDBModalRef;
  filteredCountries: InstaCitiCountries[];
  selecteeCountry=""
  constructor(
    @Inject(DOCUMENT) private document: any,
    public title: Title,
    private service: InstacitiNewService,
    private modalService: MDBModalService,
    private route: Router,
    private mapsAPILoader: MapsAPILoader,
    private routeParam: ActivatedRoute
  ) {
    document.body.classList.remove("mat-typography");
    title.setTitle("InstaCiti Portal");

    // document.head.querySelectorAll("link").forEach((element) => {
    //   if (element.rel === "stylesheet") {
    //     element.parentNode.removeChild(element);
    //   }
    // });
  }

  ngOnInit(): void {
    this.loadToolTipJS();
    this.getInstacitiGlbalData();
    this.getCountries();
  }

  loadToolTipJS() {
    setTimeout(() => {
      Tooltip();
    }, 400);
  }
  filterCountries(e){
    this.filteredCountries = this.countries.filter(data=>data.CountryName.toLowerCase().includes(e.target.value.toLowerCase()))
  }
  getCountryCode(country: any): string {
      return country.CountryName;
  }


  getInstacitiGlbalData() {
    this.service.getInstacitiGlbalData().subscribe((res) => {
      this.manikJson = res.ManikJSon[0];
      this.service.setGlobalJsonData(this.manikJson);
      this.service.instaSubject.next(true);
      let favIcon: HTMLLinkElement = this.document.querySelector("#favIcon");
      favIcon.href = this.manikJson.JSon0[0].FaviconURL;
      this.manikJson.JSon1.forEach((element) => {
        switch (element.SectionIdentifier) {
          case "HERO.QUICK":
            this.isQuickVisible = element.HideDisplay === "Y";
            break;
          case "HERO.PROMOTED":
            this.isPromotedVisible = element.HideDisplay === "Y";
            break;
          case "COLLECTION.LEVEL1":
            this.isPopularVisible = element.HideDisplay === "Y";
            break;
          case "COLLECTION.LEVEL2":
            this.isOtherVisible = element.HideDisplay === "Y";
            break;
          default:
            break;
        }
      });
    });
  }

  checkLocalStorage() {
    const nearMe = localStorage.getItem("near-me");
    this.selectedCountry = JSON.parse(
      localStorage.getItem("InstaSelectedCountry")
    );
    this.selectedCity = JSON.parse(localStorage.getItem("InstaSelectedCity"));
    let keyWord = JSON.parse(localStorage.getItem("InstaSelectedKeyword"));
    if (nearMe && nearMe === "1") {
      this.setCurrentLocation();
    } else if (!this.selectedCountry) {
      this.service.getCountryFromIpAddress().subscribe(data=>{
        this.selectedCountry = this.countries.find(item=>item.CountryAbbreviation == data.country_code)
        this.selectCountry(this.selectedCountry)
      })
      // this.detectLocationOnLoad();
    } else if (!this.selectedCity) {
      this.selectCountry(this.selectedCountry);
    } else {
      this.searchText = this.selectedCity.CityName
        ? this.selectedCity.CityName
        : this.selectedCity.LocName;
      this.location = this.selectedCity.City;
      this.locality = this.selectedCity.Locality;
      this.service.setSelectedCountry(this.selectedCountry);
      this.service.setSelectedCity(this.selectedCity);
      sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
      this.service.GetPopularCities(this.selectedCountry).subscribe((res) => {
        this.popularCities = res.ManikJSon[0].JSon0;
      });
    }
    if (keyWord) {
      this.selectedKeyWord = keyWord;
    }
  }

  selectCountry(country) {
    this.selectedCountry = country;
    this.searchText = this.selectedCountry.CityName;
    this.location = this.selectedCountry.CityName;
    this.locality = "";
    this.service.setSelectedCountry(this.selectedCountry);
    sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
    this.service.GetPopularCities(country).subscribe((res) => {
      this.popularCities = res.ManikJSon[0].JSon0;
      this.selectedCity = this.popularCities.find((val) => {
        return val.CityID === this.selectedCountry.LandingCityID;
      });
      this.service.setSelectedCity(this.selectedCity);
    });
  }
  selectCountry2(country) {
    this.selectedCountry = this.countries.find(item=>item.CountryName == country) ;
    this.searchText = this.selectedCountry.CityName;
    this.location = this.selectedCountry.CityName;
    this.locality = "";
    this.service.setSelectedCountry(this.selectedCountry);
    this.selecteeCountry = ""
    sessionStorage.setItem("PortalDS", this.selectedCountry.CountryDBContext);
    this.service.GetPopularCities(this.selectedCountry).subscribe((res) => {
      this.popularCities = res.ManikJSon[0].JSon0;
      this.selectedCity = this.popularCities.find((val) => {
        return val.CityID === this.selectedCountry.LandingCityID;
      });
      this.service.setSelectedCity(this.selectedCity);
    });
  }

  getCountries() {
   
    this.service.GetCountries().subscribe((res) => {
      this.countries = res.ManikJSon[0].JSon0;
      this.filteredCountries = this.countries
     
      this.checkLocalStorage();
    });
  }
  detectLocationOnLoad() {
    this.mapsAPILoader.load().then(() => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 8;
            this.geoCoder = new google.maps.Geocoder();
            this.geoCoder.geocode(
              { location: { lat: this.latitude, lng: this.longitude } },
              (results, status) => {
                if (status === "OK") {
                  console.log(results);
                  if (results[0]) {
                    this.zoom = 12;
                    this.address = results[0].formatted_address;
                    var arr = this.address.split(",");
                    if (arr.length) {
                      this.selectCountry(
                        this.countries.find((c) =>
                          arr[arr.length - 1]
                            .trim()
                            .includes(c.CountryName.trim())
                        )
                      );
                    } else {
                      this.selectCountry(
                        this.countries.find((c) => c.CountryID === 100000)
                      );
                    }
                  } else {
                    window.alert("No results found");
                  }
                } else {
                  window.alert("Geocoder failed due to: " + status);
                }
              }
            );
          },
          (error) => {
            this.selectCountry(
              this.countries.find((c) => c.CountryID === 100000)
            );
          }
        );
      }
    });
  }
  setCurrentLocation() {
    this.mapsAPILoader.load().then(() => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.locationDetected = true;
          localStorage.setItem("near-me", "1");
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.zoom = 8;
          this.getAddress(this.latitude, this.longitude);
        });
      }
      this.geoCoder = new google.maps.Geocoder();
    });
  }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          console.log(results);
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            var arr = this.address.split(",");
            if (arr.length > 1) {
              this.searchText = arr[arr.length - 2].concat(
                ",",
                arr[arr.length - 1]
              );
              this.selectedCountry = this.countries.find((c) =>
                c.CountryName.includes(arr[arr.length - 1].trim())
              );
              this.service.setSelectedCountry(this.selectedCountry);
              sessionStorage.setItem(
                "PortalDS",
                this.selectedCountry.CountryDBContext
              );
              this.service
                .GetPopularCities(this.selectedCountry)
                .subscribe((res) => {
                  this.popularCities = res.ManikJSon[0].JSon0;
                });
            } else {
              this.searchText = this.address;
              this.selectedCountry = this.countries.find(
                (c) => c.CountryID === 100000
              );
              this.service.setSelectedCountry(this.selectedCountry);
              sessionStorage.setItem(
                "PortalDS",
                this.selectedCountry.CountryDBContext
              );
              this.service
                .GetPopularCities(this.selectedCountry)
                .subscribe((res) => {
                  this.popularCities = res.ManikJSon[0].JSon0;
                });
            }
            this.location = this.searchText;
            this.locality = "";
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
  getNearBy() {
    this.service
      .GetNearByLocalities({
        CountryID: this.selectedCountry.CountryID,
        Latitude: this.latitude ? this.latitude : this.selectedCountry.Latitude,
        Longitude: this.longitude
          ? this.longitude
          : this.selectedCountry.Longitude,
        portalds: this.selectedCountry.CountryDBContext,
        SearchText: this.searchText || "",
      })
      .subscribe((res) => {
        this.nearby = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 20)
          : [];
      });
  }
  focus(event: any) {
    this.placeholder = this.selectedKeyWord.Keywd
      ? this.selectedKeyWord.Keywd
      : "Type to search...";
    this.selectedKeyWord.Keywd = "";
    this.search(event);
  }
  focusLocation() {
    this.localityPlaceholder = this.searchText
      ? this.searchText
      : "Type to search...";
    this.searchText = "";
    this.getNearBy();
  }
  search(event: any) {
    const keyword = event.target.value;
    console.log("zdsfdgf",this.selectedCity,this.selectedCountry);
    
    this.service
      .SearchByKeyword(
        this.selectedCity ? this.selectedCity : this.selectedCountry,
        keyword.trim()
      )
      .subscribe((res) => {
        this.searchResult = res.ManikJSon[0].JSon0.length
          ? res.ManikJSon[0].JSon0.slice(0, 50)
          : [];
      });
  }

  support() {
    this.modalRef = this.modalService.show(InstacitiSupportComponent, {
      backdrop: true,
      keyboard: false,
      ignoreBackdropClick: true,
      data: {
        CountriesList: this.countries,
        SelectedCountryID: this.selectedCountry.CountryID,
      },
    });
  }
  selectNearByCity(city) {
    localStorage.removeItem("near-me");
    this.locationDetected = false;
    this.selectedCity = city;
    this.service.setSelectedCity(this.selectedCity);
    this.location = city.City;
    this.locality = city.Locality;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  selectPopularCity(city) {
    localStorage.removeItem("near-me");
    this.locationDetected = false;
    this.selectedCity = city;
    this.service.setSelectedCity(this.selectedCity);
    this.location = city.City;
    this.locality = city.Locality;
    this.searchText = city.LocName;
    let locn = location.pathname.replace(
      this.routeParam.snapshot.params["locality"],
      this.selectedCity.URLName.trim()
    );
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(locn);
  }
  onChange(item) {
    this.selectedKeyWord = item;
    localStorage.setItem("InstaSelectedKeyword", JSON.stringify(item));
    if (item.Tgt === "S") {
      this.route.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.route.navigateByUrl(
        (this.locationDetected ? "near-me" : this.selectedCity.URLName.trim()) +
          "/" +
          item.URL
      );
    } else if (item.Tgt === "N") {
      this.GoToBizSpot(item.URL);
    }
  }
  GoToBizSpot(url) {
    window.open(url, "_blank");
  }
}
